import * as React from 'react';
export var useWindowWidth = function () {
    var _a = React.useState(window.innerWidth), width = _a[0], setWidth = _a[1];
    React.useEffect(function () {
        var handleResize = function () { return setWidth(window.innerWidth); };
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return width;
};
//# sourceMappingURL=index.js.map